import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

import { DoneIcon, QuestionIcon } from '../assets';
import { COLORS, SECOND, cn, useToastsStore } from '../lib';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const isInWelcomeShell = useToastsStore((state) => state.isInWelcomeShell);

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className={cn('toaster group flex justify-center', {
        'onboarding-lg:!left-1/4': isInWelcomeShell,
      })}
      position="top-center"
      offset={{ top: '20px' }}
      mobileOffset={{ top: '20px', left: 'auto', right: 'auto' }}
      swipeDirections={['top']}
      duration={SECOND * 3}
      visibleToasts={1}
      icons={{
        success: <DoneIcon color={COLORS['contrast-500']} />,
        error: <QuestionIcon color={COLORS['contrast-500']} />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'bg-contrast-500 text-center py-[15px] !w-auto max-w-[287px] gap-2 px-5 toast rounded-[100px] group-[.toaster]:text-black !mx-auto !left-auto !right-auto',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-brand-500 group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          title: 'typography-14r',
          icon: '!size-6',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
